import React from 'react';

function SkeletonCard() {
  return (
    <div className="flex flex-col items-center justify-center gap-6 rounded-[10px] bg-white p-6">
      <div className="flex h-[120px] w-full items-center justify-center">
        <div className="h-[60px] w-[200px] animate-pulse rounded bg-gray-200" />
      </div>
      <span className="h-[1px] w-full bg-[#BBB9BA]"></span>
      <div className="flex w-full flex-col items-start gap-2">
        <div className="h-5 w-1/3 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-1/2 animate-pulse rounded bg-gray-100" />
      </div>
    </div>
  );
}

export default SkeletonCard;
